import _ from 'lodash'

export default class JsonArray {
  static name = 'JsonArray'

  static parse (value) {
    if (_.isString(value)) {
      return JSON.parse(value)
    } else {
      return value
    }
  }

  static encode (value) {
    if (!value) return value

    return JSON.stringify(value || [])
  }
}
